var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindshield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 827.269,
    height: 340,
    viewBox: "0 0 827.269 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 827.269,
    height: 314.002,
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 86.181,
    height: 84.616,
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M52.42,0l52.42,92.8H0Z",
    transform: "translate(19.295 0) rotate(12)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 86.181,
    height: 84.616,
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7930",
    "data-name": "Group 7930",
    transform: "translate(-980 -383)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_404",
    "data-name": 404,
    transform: "translate(1096 657)",
    fill: "#263444",
    fontSize: 332,
    fontFamily: "GeogrotesqueCyr-Bold, Geogrotesque Cyr",
    fontWeight: 700,
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "404")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7915",
    "data-name": "Group 7915",
    transform: "translate(980 383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7914",
    "data-name": "Group 7914",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M111.8,0H715.432a72.927,72.927,0,0,1,45.957,16.017A74.74,74.74,0,0,1,787.15,57.094l38.293,167.1a74.187,74.187,0,0,1,0,32.723,69.707,69.707,0,0,1-14.271,29.239A68.608,68.608,0,0,1,785.759,306.7a71.024,71.024,0,0,1-32.033,7.3H73.5a71.025,71.025,0,0,1-32.033-7.3c-9.739-4.527-18.1-11.489-25.4-20.544A73.661,73.661,0,0,1,1.795,256.916a69.311,69.311,0,0,1,.336-32.723l38.306-167.1A70.968,70.968,0,0,1,66.2,16.017,71.9,71.9,0,0,1,111.8,0M360.352,47.349h50.131V30.637H111.8a44.467,44.467,0,0,0-26.817,9.048A44.592,44.592,0,0,0,70.012,63.707L31.729,231.155a44.44,44.44,0,0,0,0,19.147,45.776,45.776,0,0,0,8.348,17.06,43.043,43.043,0,0,0,14.632,11.831,41.34,41.34,0,0,0,18.792,4.18H753.726a41.433,41.433,0,0,0,18.8-4.18,43.232,43.232,0,0,0,14.62-11.831,41.969,41.969,0,0,0,8.695-17.06c1.4-6.267,1.044-12.533-.348-19.147L757.2,63.707a44.448,44.448,0,0,0-14.967-24.022,43.641,43.641,0,0,0-26.8-9.048H416.743V47.349h50.48c4.521,0,8.707,2.783,9.054,7.309l2.783,27.5c.347,3.136,0,5.918-1.739,8.353A10.528,10.528,0,0,1,469.656,94h-112.1a9.25,9.25,0,0,1-7.3-3.484c-2.087-2.435-2.087-5.217-2.087-8.353l2.782-27.5c.349-4.526,4.882-7.309,9.4-7.309",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M413.613,0H715.431a72.925,72.925,0,0,1,45.957,16.017A74.737,74.737,0,0,1,787.15,57.093l38.293,167.1a74.191,74.191,0,0,1,0,32.724,69.719,69.719,0,0,1-14.271,29.239A68.618,68.618,0,0,1,785.759,306.7a71.039,71.039,0,0,1-32.034,7.3H413.613V283.373H753.725a41.434,41.434,0,0,0,18.805-4.18,43.242,43.242,0,0,0,14.62-11.831,41.955,41.955,0,0,0,8.694-17.06c1.4-6.267,1.044-12.533-.347-19.148L757.2,63.707a44.459,44.459,0,0,0-14.967-24.022,43.645,43.645,0,0,0-26.8-9.049H416.743V47.349h50.479c4.522,0,8.707,2.782,9.055,7.309l2.782,27.5c.348,3.136,0,5.918-1.738,8.353A10.53,10.53,0,0,1,469.656,94H413.613Z",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M3.547,126.347,197.233.425a2.606,2.606,0,0,1,3.49.655l.36.795a2.677,2.677,0,0,1-.532,3.752L12.808,139.719a7.775,7.775,0,0,1-6.171,1.2,8.231,8.231,0,0,1-4.956-3.183l-.24-.53a7.525,7.525,0,0,1-1.2-6.164,6.783,6.783,0,0,1,3.307-4.693",
    transform: "translate(413.613 153.053) rotate(-11)",
    fill: "#333",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M3.547,126.347,197.233.425a2.606,2.606,0,0,1,3.49.655l.36.795a2.677,2.677,0,0,1-.532,3.752L12.808,139.719a7.775,7.775,0,0,1-6.171,1.2,8.231,8.231,0,0,1-4.956-3.183l-.24-.53a7.525,7.525,0,0,1-1.2-6.164,6.783,6.783,0,0,1,3.307-4.693",
    transform: "translate(413.613 153.053) rotate(-11)",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M72.331,77.946l-3.4,1.3L0,77.127,68.042,57.15l3.981-55.1L81.535,0,75.418,59.723l1.52,8.031c.584,4.243-1.2,8.888-4.607,10.191",
    transform: "translate(446.992 206.336)",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7929",
    "data-name": "Group 7929",
    transform: "translate(532.455 93.666) rotate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7926",
    "data-name": "Group 7926",
    transform: "translate(0 4.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7923",
    "data-name": "Group 7923",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7922",
    "data-name": "Group 7922",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M86.178,35.222A3.934,3.934,0,0,1,81.9,37.981c-3.39-.1-6.786-.025-10.182-.025h-1c-.067,1.107-.121,2.165-.2,3.208A29.042,29.042,0,0,1,67.38,52.928a.864.864,0,0,0,.191,1.205l.017.012c3.477,3.463,6.927,6.957,10.4,10.426a3.538,3.538,0,0,1,1.21,3.4,3.394,3.394,0,0,1-5.716,1.772c-2.981-2.887-5.9-5.839-8.842-8.771-.613-.614-1.193-1.264-1.8-1.9a27.088,27.088,0,0,1-16.289,6.5V17.341H39.654v48.1c-4.06.321-10.827-1.624-16.9-6.976l-6.018,6.8C15.492,66.678,14.263,68.1,13,69.49A3.385,3.385,0,0,1,9.255,70.54a3.238,3.238,0,0,1-2.309-2.832,3.743,3.743,0,0,1,1.129-3.125c3.349-3.741,6.677-7.5,10.022-11.244.307-.345.55-.618.287-1.163a31.8,31.8,0,0,1-2.865-13.034c-.013-.36,0-.721,0-1.184H14.436c-3.731,0-7.461.009-11.188-.028A3.36,3.36,0,0,1,.208,35.663a3.3,3.3,0,0,1,.9-3.62,3.7,3.7,0,0,1,2.775-.981H15.468c.017-.334.04-.607.04-.876,0-4.74.014-9.482-.022-14.221a1.937,1.937,0,0,0-.507-1.225c-2.829-2.887-5.7-5.725-8.548-8.59A3.429,3.429,0,0,1,10.6.708c.086.066.169.135.248.21.234.2.451.418.669.637C14.272,4.3,17.02,7.074,19.8,9.8a2.046,2.046,0,0,0,1.291.561q22.006.044,44.011,0a1.931,1.931,0,0,0,1.225-.517c2.921-2.869,5.789-5.795,8.71-8.662a3.4,3.4,0,0,1,5.8,1.337A3.18,3.18,0,0,1,80.3,5.536a9.776,9.776,0,0,1-.8.868c-2.775,2.781-5.558,5.551-8.319,8.342a1.523,1.523,0,0,0-.485.9c-.026,5.053-.013,10.105,0,15.145a1.258,1.258,0,0,0,.092.267h.852c3.309,0,6.622.078,9.925-.028a4.257,4.257,0,0,1,4.615,2.674v1.515Z",
    transform: "translate(0 13.885)",
    fill: "#c24729",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M.006,17.334A16.37,16.37,0,0,1,7.9,2.9a16.394,16.394,0,0,1,18.493-.084,16.4,16.4,0,0,1,8.047,14.518Z",
    transform: "translate(25.867 0)",
    fill: "#c24729",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7925",
    "data-name": "Group 7925",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7924",
    "data-name": "Group 7924",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M86.178,35.222A3.934,3.934,0,0,1,81.9,37.981c-3.39-.1-6.786-.025-10.182-.025h-1c-.067,1.107-.121,2.165-.2,3.208A29.042,29.042,0,0,1,67.38,52.928a.864.864,0,0,0,.191,1.205l.017.012c3.477,3.463,6.927,6.957,10.4,10.426a3.538,3.538,0,0,1,1.21,3.4,3.394,3.394,0,0,1-5.716,1.772c-2.981-2.887-5.9-5.839-8.842-8.771-.613-.614-1.193-1.264-1.8-1.9a27.088,27.088,0,0,1-16.289,6.5V17.341H39.654v48.1c-4.06.321-10.827-1.624-16.9-6.976l-6.018,6.8C15.492,66.678,14.263,68.1,13,69.49A3.385,3.385,0,0,1,9.255,70.54a3.238,3.238,0,0,1-2.309-2.832,3.743,3.743,0,0,1,1.129-3.125c3.349-3.741,6.677-7.5,10.022-11.244.307-.345.55-.618.287-1.163a31.8,31.8,0,0,1-2.865-13.034c-.013-.36,0-.721,0-1.184H14.436c-3.731,0-7.461.009-11.188-.028A3.36,3.36,0,0,1,.208,35.663a3.3,3.3,0,0,1,.9-3.62,3.7,3.7,0,0,1,2.775-.981H15.468c.017-.334.04-.607.04-.876,0-4.74.014-9.482-.022-14.221a1.937,1.937,0,0,0-.507-1.225c-2.829-2.887-5.7-5.725-8.548-8.59A3.429,3.429,0,0,1,10.6.708c.086.066.169.135.248.21.234.2.451.418.669.637C14.272,4.3,17.02,7.074,19.8,9.8a2.046,2.046,0,0,0,1.291.561q22.006.044,44.011,0a1.931,1.931,0,0,0,1.225-.517c2.921-2.869,5.789-5.795,8.71-8.662a3.4,3.4,0,0,1,5.8,1.337A3.18,3.18,0,0,1,80.3,5.536a9.776,9.776,0,0,1-.8.868c-2.775,2.781-5.558,5.551-8.319,8.342a1.523,1.523,0,0,0-.485.9c-.026,5.053-.013,10.105,0,15.145a1.258,1.258,0,0,0,.092.267h.852c3.309,0,6.622.078,9.925-.028a4.257,4.257,0,0,1,4.615,2.674v1.515Z",
    transform: "translate(0 13.885)",
    fill: "#c24729",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M.006,17.334A16.37,16.37,0,0,1,7.9,2.9a16.394,16.394,0,0,1,18.493-.084,16.4,16.4,0,0,1,8.047,14.518Z",
    transform: "translate(25.867 0)",
    fill: "#c24729",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(10.03 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7920",
    "data-name": "Group 7920",
    transform: "translate(-10.03 4.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7917",
    "data-name": "Group 7917",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7916",
    "data-name": "Group 7916",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M86.178,35.222A3.934,3.934,0,0,1,81.9,37.981c-3.39-.1-6.786-.025-10.182-.025h-1c-.067,1.107-.121,2.165-.2,3.208A29.042,29.042,0,0,1,67.38,52.928a.864.864,0,0,0,.191,1.205l.017.012c3.477,3.463,6.927,6.957,10.4,10.426a3.538,3.538,0,0,1,1.21,3.4,3.394,3.394,0,0,1-5.716,1.772c-2.981-2.887-5.9-5.839-8.842-8.771-.613-.614-1.193-1.264-1.8-1.9a27.088,27.088,0,0,1-16.289,6.5V17.341H39.654v48.1c-4.06.321-10.827-1.624-16.9-6.976l-6.018,6.8C15.492,66.678,14.263,68.1,13,69.49A3.385,3.385,0,0,1,9.255,70.54a3.238,3.238,0,0,1-2.309-2.832,3.743,3.743,0,0,1,1.129-3.125c3.349-3.741,6.677-7.5,10.022-11.244.307-.345.55-.618.287-1.163a31.8,31.8,0,0,1-2.865-13.034c-.013-.36,0-.721,0-1.184H14.436c-3.731,0-7.461.009-11.188-.028A3.36,3.36,0,0,1,.208,35.663a3.3,3.3,0,0,1,.9-3.62,3.7,3.7,0,0,1,2.775-.981H15.468c.017-.334.04-.607.04-.876,0-4.74.014-9.482-.022-14.221a1.937,1.937,0,0,0-.507-1.225c-2.829-2.887-5.7-5.725-8.548-8.59A3.429,3.429,0,0,1,10.6.708c.086.066.169.135.248.21.234.2.451.418.669.637C14.272,4.3,17.02,7.074,19.8,9.8a2.046,2.046,0,0,0,1.291.561q22.006.044,44.011,0a1.931,1.931,0,0,0,1.225-.517c2.921-2.869,5.789-5.795,8.71-8.662a3.4,3.4,0,0,1,5.8,1.337A3.18,3.18,0,0,1,80.3,5.536a9.776,9.776,0,0,1-.8.868c-2.775,2.781-5.558,5.551-8.319,8.342a1.523,1.523,0,0,0-.485.9c-.026,5.053-.013,10.105,0,15.145a1.258,1.258,0,0,0,.092.267h.852c3.309,0,6.622.078,9.925-.028a4.257,4.257,0,0,1,4.615,2.674v1.515Z",
    transform: "translate(0 13.885)",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M.006,17.334A16.37,16.37,0,0,1,7.9,2.9a16.394,16.394,0,0,1,18.493-.084,16.4,16.4,0,0,1,8.047,14.518Z",
    transform: "translate(25.867 0)",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7918",
    "data-name": "Group 7918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7916-2",
    "data-name": "Group 7916",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3108-2",
    "data-name": "Path 3108",
    d: "M86.178,35.222A3.934,3.934,0,0,1,81.9,37.981c-3.39-.1-6.786-.025-10.182-.025h-1c-.067,1.107-.121,2.165-.2,3.208A29.042,29.042,0,0,1,67.38,52.928a.864.864,0,0,0,.191,1.205l.017.012c3.477,3.463,6.927,6.957,10.4,10.426a3.538,3.538,0,0,1,1.21,3.4,3.394,3.394,0,0,1-5.716,1.772c-2.981-2.887-5.9-5.839-8.842-8.771-.613-.614-1.193-1.264-1.8-1.9a27.088,27.088,0,0,1-16.289,6.5V17.341H39.654v48.1c-4.06.321-10.827-1.624-16.9-6.976l-6.018,6.8C15.492,66.678,14.263,68.1,13,69.49A3.385,3.385,0,0,1,9.255,70.54a3.238,3.238,0,0,1-2.309-2.832,3.743,3.743,0,0,1,1.129-3.125c3.349-3.741,6.677-7.5,10.022-11.244.307-.345.55-.618.287-1.163a31.8,31.8,0,0,1-2.865-13.034c-.013-.36,0-.721,0-1.184H14.436c-3.731,0-7.461.009-11.188-.028A3.36,3.36,0,0,1,.208,35.663a3.3,3.3,0,0,1,.9-3.62,3.7,3.7,0,0,1,2.775-.981H15.468c.017-.334.04-.607.04-.876,0-4.74.014-9.482-.022-14.221a1.937,1.937,0,0,0-.507-1.225c-2.829-2.887-5.7-5.725-8.548-8.59A3.429,3.429,0,0,1,10.6.708c.086.066.169.135.248.21.234.2.451.418.669.637C14.272,4.3,17.02,7.074,19.8,9.8a2.046,2.046,0,0,0,1.291.561q22.006.044,44.011,0a1.931,1.931,0,0,0,1.225-.517c2.921-2.869,5.789-5.795,8.71-8.662a3.4,3.4,0,0,1,5.8,1.337A3.18,3.18,0,0,1,80.3,5.536a9.776,9.776,0,0,1-.8.868c-2.775,2.781-5.558,5.551-8.319,8.342a1.523,1.523,0,0,0-.485.9c-.026,5.053-.013,10.105,0,15.145a1.258,1.258,0,0,0,.092.267h.852c3.309,0,6.622.078,9.925-.028a4.257,4.257,0,0,1,4.615,2.674v1.515Z",
    transform: "translate(0 13.885)",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109-2",
    "data-name": "Path 3109",
    d: "M.006,17.334A16.37,16.37,0,0,1,7.9,2.9a16.394,16.394,0,0,1,18.493-.084,16.4,16.4,0,0,1,8.047,14.518Z",
    transform: "translate(25.867 0)",
    fill: "#263444",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindshield);
export default __webpack_public_path__ + "static/media/windshield.f535a5ede605a636a2dcd30d9338125c.svg";
export { ForwardRef as ReactComponent };